import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { v4 as uuidv4 } from 'uuid';

const CreateUUID = () => {
  const [uuid, setUuid] = useState('');
  const navigate = useNavigate();
  const location = useLocation();
  const currentQueryString = location.search; // Capture current query string
  console.log(currentQueryString);

  useEffect(() => {
    const newUuid = uuidv4();
    setUuid(newUuid);
  }, []);

  const handleSubmit = (event) => {
    event.preventDefault();
    const token = uuid;
    // Ensure the current query string is appended correctly
    const queryString = currentQueryString.startsWith('?')
      ? currentQueryString.replace('?', '&')
      : currentQueryString;
    navigate(`/survey?cid=${token}${queryString}`);
  };

  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <div style={styles.userId}>
          User ID: <span>{uuid}</span>
        </div>
        <h1 style={styles.title}>Data Donation Survey</h1>
        <form onSubmit={handleSubmit} style={styles.form}>
          <button type="submit" style={styles.button}>Start Survey</button>
        </form>
      </div>
    </div>
  );
};

const styles = {
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
    backgroundColor: '#f5f5f5',
  },
  card: {
    backgroundColor: '#fff',
    padding: '20px',
    borderRadius: '10px',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
    maxWidth: '400px',
    width: '100%',
    textAlign: 'center',
  },
  userId: {
    marginBottom: '10px',
    fontSize: '0.9rem',
    color: '#555',
    backgroundColor: '#f0f0f0',
    padding: '5px 10px',
    borderRadius: '20px',
    display: 'inline-block',
  },
  title: {
    marginBottom: '20px',
    fontSize: '1.5rem',
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
  },
  button: {
    padding: '10px 20px',
    fontSize: '1rem',
    borderRadius: '5px',
    border: 'none',
    backgroundColor: '#007BFF',
    color: '#fff',
    cursor: 'pointer',
    width: '100%',
  },
};

export default CreateUUID;
